export default __webpack_public_path__ + "static/media/pincode.18ce656c.png";